import "./cookies.css";

export function Cookies() {
  return (
    <div className="cookies">
      <h1>Cookies Policy</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eros
        dolor, pharetra nec quam vitae, suscipit pharetra ligula. Fusce in elit
        ac mauris auctor bibendum. Sed bibendum vehicula gravida. Vestibulum
        tempus dolor tellus, viverra hendrerit libero luctus pellentesque. Nulla
        sit amet eros ligula. Nunc finibus nunc sit amet nibh facilisis
        lobortis. Nunc vitae mauris sed metus convallis vulputate non a risus.
        Nulla facilisi.
      </p>
      <p className="cookiesTitle">What are Cookies?</p>
      <p>
        Quisque volutpat, justo id posuere semper, dolor arcu tincidunt est, ac
        convallis nulla nibh a dui. Vestibulum nunc enim, eleifend a urna sed,
        ultrices elementum neque. Duis cursus magna vel magna fringilla rutrum.
        Phasellus accumsan metus vel nunc sodales, eget vehicula lectus dictum.
        Sed ut blandit quam. Mauris lobortis lorem non malesuada maximus. Duis
        nec odio scelerisque, finibus ante vitae, venenatis nulla. Curabitur sit
        amet cursus nisl. Duis eu semper sem. Praesent sollicitudin orci at leo
        varius tempor. In sagittis mi non dolor mollis tincidunt. Donec
        fermentum erat eget purus iaculis consectetur. Morbi sed gravida arcu.
        Sed enim mi, mollis at ex non, consequat pharetra elit. Suspendisse nec
        ante consequat, pulvinar ligula in, imperdiet turpis. Morbi nec
        consectetur ipsum, nec elementum leo. Sed sed felis et massa fringilla
        tincidunt. Nulla rhoncus pretium leo, aliquet efficitur leo ultricies
        et. Nam fringilla nisl vel risus facilisis facilisis. Aliquam dictum,
        mauris nec fringilla congue, lectus est volutpat lectus, eu sagittis
        tellus enim et leo. Donec pretium magna vel ultrices ultrices. Sed
        imperdiet vestibulum tincidunt. Etiam sed velit tortor. Nam non lorem
        convallis, imperdiet lectus in, laoreet lorem. Cras ac odio metus.{" "}
      </p>
      <p className="cookiesTitle">First-party cookies</p>
      <p>
        Suspendisse imperdiet molestie lectus. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Proin eget purus elementum, fringilla
        lectus in, consectetur ante. In sodales efficitur suscipit. Integer
        laoreet, enim ac ullamcorper malesuada, magna arcu ultricies dolor, nec
        interdum neque purus sed nunc. Nullam ultrices enim eu consequat
        volutpat. Vestibulum pulvinar ex neque, sit amet auctor nisi maximus eu.
        Curabitur sagittis leo posuere mi elementum facilisis. Nam est eros,
        consectetur eu tellus a, aliquet rhoncus magna. Sed fringilla cursus
        hendrerit. Nam tristique tempor quam, eu dictum orci volutpat sed. Nulla
        ligula tortor, eleifend sed metus consectetur, efficitur porttitor nisi.
        Donec semper finibus neque. Praesent tempus convallis est, a sodales
        turpis. Nullam tempus ex dui, ut semper tellus vestibulum a. Curabitur
        vel nunc posuere arcu condimentum ullamcorper. Donec ex dolor, elementum
        quis viverra at, consequat sit amet lacus.
      </p>
      <p className="cookiesTitle">Third-party cookies</p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eros
        dolor, pharetra nec quam vitae, suscipit pharetra ligula. Fusce in elit
        ac mauris auctor bibendum. Sed bibendum vehicula gravida. Vestibulum
        tempus dolor tellus, viverra hendrerit libero luctus pellentesque. Nulla
        sit amet eros ligula. Nunc finibus nunc sit amet nibh facilisis
        lobortis. Nunc vitae mauris sed metus convallis vulputate non a risus.
        Nulla facilisi.
      </p>
      <p className="cookiesTitle">Essential cookies</p>
      <p>
        Quisque volutpat, justo id posuere semper, dolor arcu tincidunt est, ac
        convallis nulla nibh a dui. Vestibulum nunc enim, eleifend a urna sed,
        ultrices elementum neque. Duis cursus magna vel magna fringilla rutrum.
        Phasellus accumsan metus vel nunc sodales, eget vehicula lectus dictum.
        Sed ut blandit quam. Mauris lobortis lorem non malesuada maximus. Duis
        nec odio scelerisque, finibus ante vitae, venenatis nulla. Curabitur sit
        amet cursus nisl. Duis eu semper sem. Praesent sollicitudin orci at leo
        varius tempor. In sagittis mi non dolor mollis tincidunt. Donec
        fermentum erat eget purus iaculis consectetur. Morbi sed gravida arcu.
        Sed enim mi, mollis at ex non, consequat pharetra elit. Suspendisse nec
        ante consequat, pulvinar ligula in, imperdiet turpis. Morbi nec
        consectetur ipsum, nec elementum leo. Sed sed felis et massa fringilla
        tincidunt. Nulla rhoncus pretium leo, aliquet efficitur leo ultricies
        et. Nam fringilla nisl vel risus facilisis facilisis. Aliquam dictum,
        mauris nec fringilla congue, lectus est volutpat lectus, eu sagittis
        tellus enim et leo. Donec pretium magna vel ultrices ultrices. Sed
        imperdiet vestibulum tincidunt. Etiam sed velit tortor. Nam non lorem
        convallis, imperdiet lectus in, laoreet lorem. Cras ac odio metus.{" "}
      </p>
      <p className="cookiesTitle">Performance or analytical cookies</p>
      <p>
        Suspendisse imperdiet molestie lectus. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Proin eget purus elementum, fringilla
        lectus in, consectetur ante. In sodales efficitur suscipit. Integer
        laoreet, enim ac ullamcorper malesuada, magna arcu ultricies dolor, nec
        interdum neque purus sed nunc. Nullam ultrices enim eu consequat
        volutpat. Vestibulum pulvinar ex neque, sit amet auctor nisi maximus eu.
        Curabitur sagittis leo posuere mi elementum facilisis. Nam est eros,
        consectetur eu tellus a, aliquet rhoncus magna. Sed fringilla cursus
        hendrerit. Nam tristique tempor quam, eu dictum orci volutpat sed. Nulla
        ligula tortor, eleifend sed metus consectetur, efficitur porttitor nisi.
        Donec semper finibus neque. Praesent tempus convallis est, a sodales
        turpis. Nullam tempus ex dui, ut semper tellus vestibulum a. Curabitur
        vel nunc posuere arcu condimentum ullamcorper. Donec ex dolor, elementum
        quis viverra at, consequat sit amet lacus.
      </p>
      <p className="cookiesTitle">Technical or preference cookies</p>
      <p>
        Sed pellentesque tortor sollicitudin nunc fermentum venenatis eu quis
        lectus. Aliquam pulvinar tellus rutrum mi tincidunt, eu bibendum lectus
        rutrum. Donec et velit tempus, ultricies sem ac, luctus tortor. Sed
        accumsan ullamcorper metus, a blandit purus egestas vitae. Sed venenatis
        lacinia justo, non facilisis lectus pharetra quis. Sed consequat et nisl
        non rutrum. Mauris dictum mauris diam, sit amet posuere quam pulvinar
        vel. Pellentesque venenatis purus ac posuere tempor. Vivamus ex justo,
        pharetra sed justo a, venenatis scelerisque quam. Maecenas velit mauris,
        elementum id rhoncus sed, cursus eu dolor. Aliquam ut urna aliquet,
        hendrerit sem eu, euismod turpis. Nullam eget magna a turpis placerat
        viverra. Donec fermentum elit turpis, quis scelerisque tellus volutpat
        ac. Praesent lacinia eu risus ut scelerisque. Fusce sit amet dolor
        neque.
      </p>
      <p className="cookiesTitle">Behavioural or advertising cookies</p>
      <p>
        Suspendisse tortor lacus, blandit quis neque scelerisque, dictum maximus
        mauris. Curabitur tortor purus, auctor quis elementum id, placerat id
        ipsum. Mauris at dolor ut velit laoreet tempor. Pellentesque habitant
        morbi tristique senectus et netus et malesuada fames ac turpis egestas.
        Ut metus quam, rutrum nec erat id, lacinia viverra orci. Aenean blandit
        eu eros sed maximus. Pellentesque habitant morbi tristique senectus et
        netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis
        in faucibus orci luctus et ultrices posuere cubilia curae; Aliquam erat
        volutpat. Quisque eu augue enim. Maecenas aliquet arcu vel leo lobortis,
        efficitur rutrum turpis tincidunt. Suspendisse sit amet urna ex. In vel
        vulputate enim.
      </p>
      <p className="cookiesTitle">Social media cookies</p>
      <p>
        Nullam venenatis elit non mauris dapibus faucibus. Sed eu tincidunt est.
        Ut volutpat molestie pulvinar. Praesent laoreet, odio eu sagittis
        dictum, ex ipsum luctus augue, eu porttitor tellus nisi eget est.
        Suspendisse potenti. Nam non venenatis velit, non hendrerit dui.
        Maecenas at urna ultrices, condimentum velit vel, imperdiet purus.
        Integer felis diam, eleifend quis lectus porta, malesuada dictum leo.
        Sed rutrum maximus sapien, et tincidunt ante. Integer bibendum velit
        ante, congue cursus ipsum aliquam quis. Mauris ut enim pharetra, viverra
        diam a, egestas turpis. Proin nec porta purus. Curabitur mattis mattis
        est, vel ullamcorper elit euismod in. Curabitur nec semper quam.
        Pellentesque consectetur libero ut ultrices posuere.
      </p>
    </div>
  );
}
